import React, { Component } from 'react';

import FinancialPlanHeader from '../../FinancialPlanHeaderView';
import ProgressChart from './ProgressChart/ProgressChartContainer';
import Explanations from '../../Explanations/ExplanationsContainer';

export default class DisabilityView extends Component {
  render() {
    const {
      isPrint,
      clientId,
      fpId,
      goalId,
      subgoalId,
      selectedOwnerName,
      note,
      setSelectedOwnerIndex,
      selectedOwnerIndex,
      subgoalData,
    } = this.props;

    return (
      <div className="NewFinancialPlan_Insurance_Disability">
        <div
          className={`NewFinancialPlan_header
                ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
            `}
        >
          <FinancialPlanHeader
            {...this.props}
            showCalibration={false}
            hideOldDescription={false}
            printTitle={`Disability Insurance: ${selectedOwnerName}`}
          />
        </div>
        {!isPrint && <Explanations clientId={clientId} />}
        <ProgressChart
          isPrint={isPrint}
          clientId={clientId}
          goalId={goalId}
          fpId={fpId}
          subgoalId={subgoalId}
          subgoalData={subgoalData}
          note={note}
          principalName={subgoalData.PrincipalName}
          spouseName={subgoalData.SpouseName}
          setSelectedOwnerIndex={setSelectedOwnerIndex(clientId, goalId)}
          {...(isPrint ? { ownerIndex: selectedOwnerIndex, tabId: subgoalId } : {})}
        />
      </div>
    );
  }
}
